import { Component, Input } from '@angular/core';
import { OfferServicesInterface } from '../../../data-access/models/interface/offer-services.interface';

@Component({
  selector: 'tic-offer-services',
  templateUrl: './offer-services.component.html',
  styleUrls: ['./offer-services.component.scss']
})
export class OfferServicesComponent {
  @Input() itemList!: OfferServicesInterface[];
}
